// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TagIconSignature {
  Element: SVGSVGElement;
}

export const TagIcon: TOC<TagIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 22C13.744 22 13.488 21.902 13.293 21.707L2.293 10.707C2.105 10.52 2 10.266 2 10V3C2 2.447 2.447 2 3 2H10C10.266 2 10.52 2.105 10.707 2.293L21.707 13.293C22.098 13.684 22.098 14.316 21.707 14.707L14.707 21.707C14.512 21.902 14.256 22 14 22ZM4 9.586L14 19.586L19.586 14L9.586 4H4V9.586ZM7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"/>
</svg>
</template>;